/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Source_LicensingInputs */

const en_svchip_source_licensing = /** @type {(inputs: Svchip_Source_LicensingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source licensing`)
};

const ar_svchip_source_licensing = /** @type {(inputs: Svchip_Source_LicensingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ترخيص المصادر`)
};

const bn_svchip_source_licensing = /** @type {(inputs: Svchip_Source_LicensingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সোর্স লাইসেন্সিং`)
};

const de_svchip_source_licensing = /** @type {(inputs: Svchip_Source_LicensingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelllizenzierung`)
};

const es_svchip_source_licensing = /** @type {(inputs: Svchip_Source_LicensingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Licencia de fuente`)
};

const fr_svchip_source_licensing = /** @type {(inputs: Svchip_Source_LicensingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Licence source`)
};

const pt_svchip_source_licensing = /** @type {(inputs: Svchip_Source_LicensingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Licenciamento de origem`)
};

const zh_svchip_source_licensing = /** @type {(inputs: Svchip_Source_LicensingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`源许可`)
};

const tr_svchip_source_licensing = /** @type {(inputs: Svchip_Source_LicensingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaynak lisanslaması`)
};

const ru_svchip_source_licensing = /** @type {(inputs: Svchip_Source_LicensingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лицензирование исходного кода`)
};

const pl_svchip_source_licensing = /** @type {(inputs: Svchip_Source_LicensingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Licencja źródłowa`)
};

/**
* | output |
* | --- |
* | "Source licensing" |
*
* @param {Svchip_Source_LicensingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_source_licensing = /** @type {((inputs?: Svchip_Source_LicensingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Source_LicensingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_source_licensing(inputs)
	if (locale === "bn") return bn_svchip_source_licensing(inputs)
	if (locale === "de") return de_svchip_source_licensing(inputs)
	if (locale === "es") return es_svchip_source_licensing(inputs)
	if (locale === "fr") return fr_svchip_source_licensing(inputs)
	if (locale === "pt") return pt_svchip_source_licensing(inputs)
	if (locale === "zh") return zh_svchip_source_licensing(inputs)
	if (locale === "tr") return tr_svchip_source_licensing(inputs)
	if (locale === "ru") return ru_svchip_source_licensing(inputs)
	if (locale === "pl") return pl_svchip_source_licensing(inputs)
	return en_svchip_source_licensing(inputs)
});